import { Category } from "@CommonApi/categories";
import { omniAtom } from "src/utils/atoms";

export const importJdaBaselineModalDataAtom = omniAtom({
  prefix: "src/modals/importJdaBaseline",
  key: "data",
  value: null as null | Category,
});
